import React from "react";
import { CardShell } from "./card-handler";

interface DelayConfig {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

interface SetDelayTimeCardProps {
  config: DelayConfig;
  onUpdate: (config: DelayConfig) => void;
  onDelete: () => void;
  onReset: () => void;
  bare?: boolean;
}

export const SetDelayTimeCard: React.FC<SetDelayTimeCardProps> = ({
  config,
  onUpdate,
  onDelete,
  onReset,
  bare,
}) => {
  const updateField = (key: keyof DelayConfig, value: string) => {
    const num = parseInt(value, 10);
    onUpdate({ ...config, [key]: isNaN(num) ? 0 : num });
  };

  // Force defaults if not set
  const displayConfig: Required<DelayConfig> = {
    days: config.days ?? 2,
    hours: config.hours ?? 3,
    minutes: config.minutes ?? 30,
    seconds: config.seconds ?? 0,
  };

  return (
    <CardShell title="Set Delay Time" onDelete={onDelete} onReset={onReset} bare={bare}>
        <div className="grid grid-cols-4 gap-2 mb-1">
          {["Days", "Hours", "Minutes", "Seconds"].map((label) => (
            <span key={label} className="text-xs text-gray-500 dark:text-gray-400 text-center font-medium">
              {label}
            </span>
          ))}
        </div>

        <div className="grid grid-cols-4 gap-2">
          <input
            type="number"
            min={0}
            value={displayConfig.days}
            onChange={(e) => updateField("days", e.target.value)}
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-center outline-none focus:ring-1 focus:ring-indigo-300"
          />
          <input
            type="number"
            min={0}
            value={displayConfig.hours}
            onChange={(e) => updateField("hours", e.target.value)}
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-center outline-none focus:ring-1 focus:ring-indigo-300"
          />
          <input
            type="number"
            min={0}
            value={displayConfig.minutes}
            onChange={(e) => updateField("minutes", e.target.value)}
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-center outline-none focus:ring-1 focus:ring-indigo-300"
          />
          <input
            type="number"
            min={0}
            value={displayConfig.seconds}
            onChange={(e) => updateField("seconds", e.target.value)}
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-center outline-none focus:ring-1 focus:ring-indigo-300"
          />
        </div>
    </CardShell>
  );
};